import { useContext } from "react";
import { MainContext, PlayMode } from "../App";
import { Button, Radio } from "antd";
import { PauseOutlined } from "@ant-design/icons";
import {
  CharacterHandler as CH,
  CharacterState,
  StatusType,
} from "../controllers/characters";
import { statusIcons } from "./World";
import { WorldHandler } from "../controllers/world";
import { EyeOutlined } from "@ant-design/icons";
import { FactionMembership, FactionType } from "../controllers/social";
import "./CharacterRow.css";

interface Props {
  character: CharacterState;
}

const CharacterRow: React.FC<Props> = ({ character }) => {
  const { appState: context, setAppState: setContext } =
    useContext(MainContext);

  const createOnRowClick = (c: CharacterState) => (): void => {
    setContext({
      ...context,
      view: {
        ...context.view,
        characterHighlighted: c.id,
      },
    });
  };

  let characters: CharacterState[] = [];

  if (context.view.squareHighlighted) {
    characters = WorldHandler.getAllCharactersAtPos(
      context.view.squareHighlighted,
      context.world
    );
  }

  const age = Math.round(CH.age(character) / 12); //age in years (currently)
  const ageTag = CH.ageTag(character).toLowerCase();
  const family = character.factions.find(
    (f) => f.factionType === FactionType.FAMILY
  ) as FactionMembership;

  return (
    <div
      className={`character-row char-row-${ageTag}`}
      key={`char-row-${character.id}`}
    >
      <div className="char-row-name">{`${character.firstname} ${character.lastname}`}</div>
      <div className="char-row-status">
        {character.statusList
          .filter((s) => s.type !== StatusType.ALIVE)
          .map((s) => (
            <span
              key={`char-row-status-${
                character.id
              }-${s.type.toLocaleLowerCase()}`}
            >
              {statusIcons[s.type]}
            </span>
          ))}
      </div>
      <div className="char-row-age">{age}</div>
      <div className="char-row-hp">{`${CH.hp(character)}/${CH.hpMax(
        character
      )}`}</div>
      <div className="char-row-pos-influence">
        {
          character.factions.find((f) => f.factionType === FactionType.POS)
            ?.influence
        }
      </div>
      <div className="char-row-family">{family.factionName}</div>
      <Button onClick={createOnRowClick(character)} size="small">
        <EyeOutlined />
      </Button>
    </div>
  );
};

export default CharacterRow;
